import { initAccordion } from '../objects/accordion/accordion';
import { CLASS_ACTIVE, CLASS_INITIALISED } from '../tools/constants/classes';

// Selectors
const SELECTOR_CONTAINER = '[data-product-faqs]';
const SELECTOR_ACCORDION = '[data-accordion-container]';

const ATTR_INDEX = 'data-results-index';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((containerElement) => {
    // Check if section has already been initialized
    if (containerElement.classList.contains(CLASS_INITIALISED)) return;
    containerElement.classList.add(CLASS_INITIALISED);

    const accordionContainer =
      containerElement.querySelector<HTMLDetailsElement>(SELECTOR_ACCORDION);

    if (!accordionContainer) return;

    // Initialize accordion
    initAccordion({ container: accordionContainer });
  });
